import PropTypes from "prop-types";
import Link from "next/link";
import CustomImage from "../../../atoms/customImage";
import Typography from "../../../atoms/typography";
import useAnalytics from "../../../../analytics/useAnalytics";
import { cleverTapCommonEvents } from "../../../../analytics/clevertapConstants";
import { GA4_EVENTS } from "../../../../analytics/gaConstant";
import { formatClassNames } from "../../../../utils/common";
import { usePathname } from "next/navigation";
import { areUrlsSame } from "../../../../utils/common";

/** */
const Suggestions = ({ searchSuggestion, searchEventCommonData, isFromPDP, isSearch, onNavigate = () => {} }) => {
  const { trackEvent } = useAnalytics();
  const pathname = usePathname();
  /**
   * Tracks a search event with Analytics.
   *
   * @param {Object} item - The search item object.
   */
  const onSearchTrackEvent = (item) => {
    const clevertapSearchData = {
      ...searchEventCommonData,
      search: item?.categoryName || item?.keyword,
      is_popular_search: item?.suggestionResponseType === "PR",
      is_recent_search: item?.suggestionResponseType === "RS",
      is_manual_boost: item?.suggestionResponseType === "MB",
    };
    trackEvent(cleverTapCommonEvents.searched, clevertapSearchData, ["clevertap"]);
    trackEvent(GA4_EVENTS?.SEARCH, { search: item?.categoryName ? item?.categoryName : item?.keyword || null }, [
      "ga4",
    ]);
  };
  /** */
  const renderListItem = (item) => {
    if (item.keyword || item?.categoryName) {
      return (
        <li className="flex w-full border-b-1" key={item?.url ? item?.url : item?.targetUrl}>
          <Link
            href={item?.url ? item?.url : item?.targetUrl}
            className="flex w-full items-center gap-8 py-16 text-14 font-400 text-fnp-500"
            // eslint-disable-next-line react/jsx-handler-names
            onClick={() => {
              onSearchTrackEvent(item);
              const href = item?.url || item?.targetUrl;
              if (href && !areUrlsSame(pathname, href)) {
                onNavigate();
              }
            }}
          >
            <div className="w-20">
              <CustomImage
                src={item?.suggestionResponseType === "RS" ? "/icons/clock.svg" : "/icons/search-normal.svg"}
                width={20}
                height={20}
                isPriority={false}
                sizes="10vw"
                alt="search icons"
              />
            </div>
            <Typography
              Tag="p"
              variant="h6"
              classes="block text-14 font-normal text-fnp-500 w-[calc(100%-28px)] overflow-hidden text-ellipsis whitespace-nowrap"
            >
              {item?.categoryName ? item?.categoryName : item?.keyword}
            </Typography>
          </Link>
        </li>
      );
    }
  };
  return (
    <div
      className={formatClassNames(
        "absolute left-0 top-[100%] z-50 w-full max-w-[651px]",
        (isFromPDP || isSearch) && "xmll:left-[24px] xll:left-[66px] xxl:left-[136px]",
      )}
    >
      <div className="max-h-416 w-full overflow-auto rounded-b-8 bg-white-900 p-10 pb-0 drop-shadow-md scrollbar-thin scrollbar-webkit">
        <ul>{searchSuggestion?.length > 0 && searchSuggestion?.map((item) => renderListItem(item))}</ul>
      </div>
    </div>
  );
};
Suggestions.propTypes = {
  searchSuggestion: PropTypes.array.isRequired,
  searchEventCommonData: PropTypes.object,
  isFromPDP: PropTypes.bool,
  isSearch: PropTypes.bool,
  onNavigate: PropTypes.func,
};
export default Suggestions;
